<template>
    <div>
        <b-row>
            <b-col sm="25" md="4">
                <b-form-group>
                    <label
                        class="required"
                    >Total Hs CT</label>
                    <b-form-textarea
                        v-model="campoLivre1"
                        :maxlength="40"
                    ></b-form-textarea>
                </b-form-group>          
            </b-col>
            <b-col sm="25" md="4">
                <b-form-group>
                    <label
                        class="required"
                    >Saldo Hs Ant</label>
                    <b-form-textarea
                        v-model="campoLivre2"
                        :maxlength="40"
                    ></b-form-textarea>
                </b-form-group>          
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        item: {
            type: Object,
            default: () => {}
        },
        acao: {
            type: String,
            default: () => ""
        }
    },
    data(){
        return{
            campoLivre1: '',
            campoLivre2: ''
        }
    },

    methods: {
        verificarAcao() {
            if (this.acao == 'Inserir'){
                this.preencherFormInserir()
            } else {
                this.preencherFormAtualizar()
            }
        },

        preencherFormInserir() {
            
        },

        preencherFormAtualizar() {
            this.campoLivre1 = this.item.campoLivre1
            this.campoLivre2 = this.item.campoLivre2
        },
    },

    computed: {
        observacao() {
            return {
                campoLivre1: this.campoLivre1,
                campoLivre2: this.campoLivre2,
                invalid: this.$v.$invalid
            }
        }
    },

    created() {
        this.verificarAcao()
    },

    watch: {
        observacao() {
            this.$emit('atualizarObservacao', this.observacao)
        }
    },

    validations: {
        campoLivre1: {
            required
        },
        campoLivre2: {
            required
        }
    }

}
</script>

<style>

</style>